import { useState } from "react";
import * as Option from "@utils/Option";
import type { OptionTs, TaskTs } from "@ps-bridge/interop";
import { taskFromRaw } from "@utils/effects/branded";

// Custom hook for selecting a file
export const useFilePicker = () => {
  const [_file, setFile] = useState<OptionTs<File>>(Option.none());

  const selectFile = (): TaskTs<OptionTs<File>> =>
    taskFromRaw(
      () =>
        new Promise<OptionTs<File>>((resolve) => {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = ".txt";
          input.style.display = "none";
          document.body.appendChild(input);

          let resolved = false;

          const cleanup = () => {
            input.removeEventListener("change", handleChange);
            input.removeEventListener("cancel", handleCancel);
            window.removeEventListener("focus", handleWindowFocus);
            input.remove();
          };

          const finish = (optionFile: OptionTs<File>) => {
            if (resolved) {
              return;
            }
            resolved = true;
            setFile(optionFile);
            resolve(optionFile);
            cleanup();
          };

          const handleChange = () => {
            const selectedFile = input.files?.[0];
            finish(selectedFile ? Option.some(selectedFile) : Option.none());
          };

          const handleCancel = () => {
            finish(Option.none());
          };

          const handleWindowFocus = () => {
            setTimeout(() => {
              if (!resolved) {
                const selectedFile = input.files?.[0];
                finish(selectedFile ? Option.some(selectedFile) : Option.none());
              }
            }, 0);
          };

          input.addEventListener("change", handleChange);
          input.addEventListener("cancel", handleCancel);
          window.addEventListener("focus", handleWindowFocus);

          input.click();
        }),
    );

  return {
    selectFile,
  };
};
